import { FunctionComponent } from 'react';
import styled from 'styled-components';

import theme from '@/styles/theme';
import { DIRECTION } from '@/types/common';

interface Props {
  direction?: DIRECTION;
  size?: number;
  color?: string;
}
const ArrowInCircle: FunctionComponent<Props> = ({
  direction = DIRECTION.RIGHT,
  size = 16,
  color = theme.color.white,
}) => {
  return (
    <ArrowInCircleSVG
      direction={direction}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_1728_38508)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.71199 0.00365558C7.40199 0.0174604 7.16633 0.0378636 6.89919 0.0740236C5.8055 0.222068 4.72382 0.613396 3.77279 1.20511C2.68739 1.88042 1.75155 2.83904 1.1038 3.9391C0.969715 4.16681 0.78807 4.52047 0.684986 4.75454C0.31984 5.58364 0.105338 6.4179 0.029088 7.3055C0.00733441 7.55872 0.00336641 7.66559 0.00330881 7.9999C0.00323841 8.38025 0.012736 8.56881 0.048256 8.8927C0.176986 10.0664 0.575565 11.2151 1.2052 12.2271C1.70536 13.031 2.36305 13.7564 3.12639 14.3461C3.81718 14.8798 4.61871 15.3064 5.46239 15.5894C6.06347 15.791 6.66767 15.916 7.30559 15.9708C7.56083 15.9927 7.66525 15.9966 7.99999 15.9966C8.38048 15.9966 8.5695 15.9871 8.89279 15.9516C10.0664 15.8229 11.2153 15.4243 12.2272 14.7947C12.6163 14.5526 12.9777 14.2806 13.3504 13.9494C13.462 13.8501 13.8502 13.4619 13.9494 13.3503C14.4614 12.7742 14.8403 12.216 15.1679 11.5551C15.6134 10.6564 15.8774 9.72425 15.9682 8.73007C15.9798 8.60248 15.9935 8.37651 15.9936 8.31228C15.9936 8.27786 15.9964 8.24849 16 8.2463C16.0041 8.24377 16.0064 8.15343 16.0064 7.99632C16.0064 7.83657 16.0041 7.7503 16 7.7503C15.9962 7.7503 15.9936 7.72522 15.9936 7.6879C15.9935 7.58302 15.9738 7.30899 15.9517 7.1071C15.8235 5.93502 15.4243 4.78451 14.7948 3.7727C14.5051 3.30711 14.1701 2.8765 13.7864 2.4767C13.118 1.78016 12.3994 1.25039 11.5552 0.831963C10.59 0.353537 9.6183 0.0922316 8.51874 0.0153804C8.39084 0.00644598 7.83183 -0.00168202 7.71199 0.00365558ZM7.87199 1.40599C6.51278 1.42618 5.16218 1.88736 4.06399 2.70629C3.55807 3.08356 3.08446 3.55715 2.70634 4.0639C2.28567 4.62765 1.95731 5.26075 1.73208 5.9423C1.55219 6.4867 1.44975 7.03306 1.41411 7.6383C1.4049 7.79487 1.4049 8.20493 1.41411 8.3615C1.45084 8.98511 1.55818 9.54453 1.74937 10.1087C2.13642 11.2508 2.8074 12.2385 3.73439 13.0307C4.75758 13.9051 6.06682 14.4534 7.40799 14.5692C7.78637 14.6019 8.2136 14.6019 8.59199 14.5692C9.93328 14.4534 11.2413 13.9056 12.2656 13.0307C12.5331 12.8022 12.8023 12.533 13.0307 12.2655C13.8517 11.3044 14.3852 10.0943 14.5433 8.8351C14.6005 8.37976 14.6094 7.886 14.5691 7.4079C14.4623 6.14101 13.9559 4.87986 13.1538 3.88332C12.8906 3.55628 12.587 3.24375 12.2656 2.96911C11.3046 2.14789 10.0901 1.61279 8.83199 1.45631C8.52785 1.41848 8.19735 1.40116 7.87199 1.40599ZM7.91999 5.05669C7.80378 5.06771 7.68763 5.11258 7.58967 5.18431C7.50807 5.24407 4.09794 8.65663 4.05223 8.72428C4.00618 8.79243 3.97108 8.86842 3.9508 8.9439C3.93508 9.00232 3.9336 9.01794 3.93373 9.1231C3.93386 9.22723 3.93551 9.2444 3.95085 9.30184C3.99114 9.45262 4.08821 9.59317 4.22079 9.69266C4.27789 9.73551 4.37846 9.7836 4.45119 9.80282C4.50818 9.81788 4.52745 9.81978 4.62719 9.82022C4.75531 9.82077 4.80218 9.81264 4.89905 9.77308C5.03337 9.71821 4.92938 9.81739 6.53599 8.21185L8 6.74883L9.46399 8.21187C11.0707 9.8175 10.9666 9.7182 11.1009 9.77308C11.1978 9.81264 11.2447 9.82077 11.3728 9.82022C11.4725 9.81978 11.4918 9.81788 11.5488 9.80282C11.6994 9.76302 11.8368 9.66766 11.9373 9.53325C12.0326 9.4057 12.0767 9.25483 12.0684 9.08508C12.0619 8.95062 12.0238 8.83684 11.9477 8.72428C11.902 8.65663 8.4919 5.24407 8.4103 5.18431C8.30816 5.10952 8.19884 5.06847 8.06959 5.05636C8.02955 5.05261 7.99247 5.04992 7.98719 5.05039C7.98191 5.05085 7.95167 5.05368 7.91999 5.05669ZM0.00289921 8.0031C0.00289921 8.14038 0.00374401 8.19563 0.00478081 8.12588C0.00581761 8.05612 0.00581121 7.9438 0.00477441 7.87628C0.00374401 7.80875 0.00289281 7.86582 0.00289921 8.0031Z'
          fill={color}
        />
      </g>
      <defs>
        <clipPath id='clip0_1728_38508'>
          <rect width='16' height='16' fill={color} />
        </clipPath>
      </defs>
    </ArrowInCircleSVG>
  );
};

export default ArrowInCircle;

export const ArrowInCircleSVG = styled.svg<{ direction: DIRECTION }>`
  transition: transform 0.1s linear;
  transform: rotate(
    ${({ direction }) =>
      direction === DIRECTION.TOP
        ? 0
        : direction === DIRECTION.BOTTOM
          ? 180
          : direction === DIRECTION.LEFT
            ? -90
            : 90}deg
  );
`;
